import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {MyActionManagementComponent} from './my-action-management/my-action-management.component';
import {MyActionAlmahaManagementComponent} from './my-action-almaha-management/my-action-almaha-management.component';

const routes: Routes = [
  {
    path: 'my-action-management',
    loadChildren: './my-action-others/my-action-others.module#MyActionOthersModule',
    data: {
      id: 2,
      title: 'My Action Items',
      crud: 'R'
    },
  },
  {
    path: 'my-action-almaha-management',
    loadChildren: './my-action-almaha/my-action-almaha.module#MyActionAlmahaModule',
    data: {
      id: 2,
      title: 'My Action Items',
      crud: 'R'
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyActionItemsRoutingModule {
}



// WEBPACK FOOTER //
// /app/src/app/my-action-items/my-action-items-routing.module.ts